import React, { useEffect, useState } from 'react';
import { getFirestore, collection, query, where, onSnapshot } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';

const firebaseConfig = {
  apiKey: "AIzaSyDJ_lusSO40qPa2pKdvwOOexRPU2p4Vsro",
  authDomain: "tradeahv2.firebaseapp.com",
  projectId: "tradeahv2",
  storageBucket: "tradeahv2.firebasestorage.app",
  messagingSenderId: "398274404066",
  appId: "1:398274404066:web:74be764b202f62b91f08bb"
};

initializeApp(firebaseConfig);
const db = getFirestore();

export default function ArchivePage() {
  const [signals, setSignals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all'); // 'all', 'achieved', 'stopped'

  useEffect(() => {
    let q;
    if (filter === 'all') {
      q = query(collection(db, 'signals_v2'), where('status', '!=', 'active'));
    } else {
      q = query(collection(db, 'signals_v2'), where('status', '==', filter));
    }
    
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const signalsList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      signalsList.sort((a, b) => {
        const aTime = a.closed_at?.seconds || 0;
        const bTime = b.closed_at?.seconds || 0;
        return bTime - aTime;
      });
      setSignals(signalsList);
      setLoading(false);
    }, (error) => {
      console.error("❌ Error:", error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [filter]);

  const calculateSuccessRate = () => {
    if (signals.length === 0) return 0;
    const successful = signals.filter(s => s.status === 'achieved').length;
    return Math.round((successful / signals.length) * 100);
  };

  const successRate = calculateSuccessRate();

  return (
    <div style={{ padding: '20px', direction: 'ltr', fontFamily: 'Arial' }}>
      <h1 style={{ color: '#1e40af' }}>TradeAH V2 — Archive</h1>
      
      {/* مؤشر الأداء */}
      <div style={{ 
        backgroundColor: '#f0fdf4', 
        padding: '16px', 
        borderRadius: '12px', 
        marginBottom: '24px',
        border: '1px solid #bbf7d0'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <h3 style={{ margin: 0, color: '#065f46' }}>Performance Summary</h3>
            <p style={{ margin: '4px 0 0 0', color: '#065f46' }}>
              Success Rate: <strong>{successRate}%</strong> ({signals.filter(s => s.status === 'achieved').length} successful out of {signals.length})
            </p>
          </div>
          <div style={{ 
            backgroundColor: '#dcfce7', 
            color: '#166534', 
            padding: '8px 16px', 
            borderRadius: '20px',
            fontWeight: 'bold'
          }}>
            {successRate}%
          </div>
        </div>
      </div>

      {/* فلاتر */}
      <div style={{ marginBottom: '20px', display: 'flex', gap: '12px' }}>
        <button 
          onClick={() => setFilter('all')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'all' ? '#1e40af' : '#e2e8f0',
            color: filter === 'all' ? 'white' : '#1e293b',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          All
        </button>
        <button 
          onClick={() => setFilter('achieved')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'achieved' ? '#16a34a' : '#e2e8f0',
            color: filter === 'achieved' ? 'white' : '#16a34a',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Successful
        </button>
        <button 
          onClick={() => setFilter('stopped')}
          style={{
            padding: '8px 16px',
            backgroundColor: filter === 'stopped' ? '#dc2626' : '#e2e8f0',
            color: filter === 'stopped' ? 'white' : '#dc2626',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          Failed
        </button>
      </div>

      {/* عرض التوصيات */}
      {loading ? (
        <div>Loading archive...</div>
      ) : signals.length === 0 ? (
        <p>No closed signals yet.</p>
      ) : (
        <div style={{ display: 'grid', gap: '24px' }}>
          {signals.map(signal => (
            <div 
              key={signal.id}
              style={{ 
                border: `1px solid ${signal.status === 'achieved' ? '#bbf7d0' : '#fecaca'}`, 
                padding: '16px', 
                borderRadius: '12px',
                backgroundColor: signal.status === 'achieved' ? '#f0fdf4' : '#fef2f2',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <div>
                  <h3 style={{ 
                    margin: '0', 
                    color: signal.status === 'achieved' ? '#166534' : '#b91c1c'
                  }}>
                    {signal.status === 'achieved' ? '✅' : '❌'} {signal.action} {signal.ticker}
                    {signal.ticker_name && (
                      <span style={{ fontSize: '14px', color: '#64748b', marginLeft: '8px' }}>
                        ({signal.ticker_name})
                      </span>
                    )}
                  </h3>
                  <div style={{ marginTop: '8px', display: 'flex', gap: '12px', fontSize: '14px' }}>
                    <span>Expert: <strong>{signal.expert_id ? `TradeAH_${signal.expert_id.split('_').pop()}` : 'System'}</strong></span>
                    <span>Type: <strong>{signal.signal_type}</strong></span>
                    <span>Confidence: <strong>{signal.confidence_score}%</strong></span>
                  </div>
                </div>
                <div style={{ textAlign: 'right', fontSize: '14px', color: '#475569' }}>
                  {signal.closed_at?.seconds && 
                    new Date(signal.closed_at.seconds * 1000).toLocaleDateString('en-GB')
                  }
                </div>
              </div>
              
              <div style={{ marginTop: '12px', display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>Entry</div>
                  <div style={{ fontWeight: 'bold' }}>{signal.entry_price}</div>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>Closed At</div>
                  <div style={{ fontWeight: 'bold', color: signal.status === 'achieved' ? '#16a34a' : '#dc2626' }}>
                    {signal.closed_price}
                  </div>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>Target</div>
                  <div style={{ fontWeight: 'bold' }}>{signal.take_profit}</div>
                </div>
                <div>
                  <div style={{ fontSize: '12px', color: '#64748b' }}>Stop Loss</div>
                  <div style={{ fontWeight: 'bold' }}>{signal.stop_loss}</div>
                </div>
              </div>
              
              {/* ملاحظة الأداء */}
              {signal.performance_note && (
                <div style={{ 
                  marginTop: '12px', 
                  padding: '10px', 
                  backgroundColor: '#f1f5f9', 
                  borderRadius: '8px',
                  fontSize: '13px',
                  color: '#334155'
                }}>
                  📝 {signal.performance_note}
                </div>
              )}

              {/* رابط عرض التفاصيل */}
              <div 
                onClick={() => window.location.href = `/signal/${signal.id}`}
                style={{ 
                  cursor: 'pointer', 
                  color: '#1e40af',
                  fontWeight: 'bold',
                  marginTop: '16px',
                  textAlign: 'center',
                  padding: '8px',
                  borderRadius: '6px',
                  backgroundColor: '#eff6ff',
                  width: 'fit-content',
                  margin: '12px auto 0'
                }}
              >
                📊 عرض التفاصيل الكاملة
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}